import { useEffect, useState } from "react";
import axios from 'axios';
import { useNavigate, Link, useParams, useSearchParams } from "react-router-dom";
import GoogleMapComponent from "./../../../components/GoogleMapComponent";
import AlertMessage from "../../include/AlertMessage";
var _ = require('lodash');

function EditCouponRedemtion() {
    const [searchParams] = useSearchParams();
    const page = searchParams.get("page") || 1;

    const [alert, setAlert] = useState({ type: "", message: "" });
    const [errors, setErrors] = useState({});
    const redirectHistory = useNavigate();
    const { id } = useParams();
    const token = sessionStorage.getItem('JWT_TOKEN');
    const [allUsers, setallUsers] = useState([]);
    const [loading, setLoading] = useState(true);
    const [formData, setFormData] = useState({ latitude: '', longitude: '', users: '' });

    const validate = () => {
        const newErrors = {};
        if (!formData.latitude) newErrors.latitude = "Latitude is required.";
        if (!formData.longitude) newErrors.longitude = "Longitude is required.";
        if (!formData.users) newErrors.users = "User is required.";
        return newErrors;
    };


    const fetchAllUsers = async () => {
        try {
            const response = await axios.get(`${process.env.REACT_APP_API_URL}/customers`, {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': 'Bearer ' + token // Replace with your token
                }
            });
            const userdata = await response.data;
            if (Array.isArray(userdata.data) && userdata.data.length > 0) {
                setallUsers(userdata.data);
            } else {
                setallUsers([]);
            }
        } catch (err) {
            const apierror = _.get(err, ['response', 'data', 'error', 'message'], "Something went wrong");
            setAlert({ type: "error", message: apierror });            
        } finally {
            setLoading(false);
        }

    };

    // Define an async function inside useEffect
    const fetchData = async () => {
        try {

            const response = await axios.get(`${process.env.REACT_APP_API_URL}/fetchdetail/${id}`, {
                headers: {
                    'Authorization': 'Bearer ' + token // Replace with your token
                }
            });


            const resdata = response.data.data;

            const customdata = {
                latitude: resdata.latitude,
                longitude: resdata.longitude,
                users: resdata.user,
                //coupons: resdata.coupons.name,
                //couponID: resdata.coupons.$id
                couponID: resdata.coupons
            }
            setFormData(customdata); // Set data to state           
        } catch (error) {
            const apierror = _.get(error, ['response', 'data', 'error', 'message'], "Something went wrong");
            setAlert({ type: "error", message: apierror });
        }
    };


    useEffect(() => {
        document.documentElement.className = "";

        fetchAllUsers();
        fetchData(); // Call the async function                
    }, [id]);


    const handleEdit = async (e) => {
        e.preventDefault();
        const newErrors = validate();
        setErrors(newErrors);
        if (Object.keys(newErrors).length === 0) {
            try {
                //API URL
                const response = await axios.put(`${process.env.REACT_APP_API_URL}/editcouponredemtion/${id}`, {
                    "latitude": formData.latitude,
                    "longitude": formData.longitude,
                    "users": formData.users,
                    "coupons": formData.couponID
                },
                    {
                        headers: {
                            'Content-Type': 'application/json',
                            'Authorization': 'Bearer ' + token // Replace with your token
                        }
                    }
                );

                if (response.status === 200 || response.status === 201) {
                    //alert('Module added successfully!');
                    const redirectPath = `/couponredemtions/${formData.couponID}?page=${page}`;
                    setAlert({ type: "success", message: "Coupon redemption updated successfully." });
                    setTimeout(() => redirectHistory(redirectPath), 2500); // thoda delay deke redirect                                    
                }

            } catch (err) {
                const apierror = _.get(err, ['response', 'data', 'error', 'message'], "Failed to edit coupon redemption. Please try again.");
                setAlert({ type: "error", message: apierror });
            }

        }
    }

    const handleLocationSelect = ({ lat, lng }) => {
        setFormData((prev) => ({
            ...prev,
            latitude: lat,
            longitude: lng,
        }));
    };

    return (
        <section>
            <div className="is-title-bar">
                <div className="flex flex-col md:flex-row items-center justify-between space-y-6 md:space-y-0">
                    <ul>
                        <li><Link to="/dashboard" className='btn btn-primary'>Dashboard</Link></li>
                        <li><Link to="/coupons" className='btn btn-primary'>Coupons</Link></li>
                        <li><Link to={`/couponredemtions/${formData.couponID}?page=${page}`} className='btn btn-primary'>Redemptions</Link></li>
                        <li>Edit</li>
                    </ul>
                </div>
            </div>
            <div className="section main-section">
                <div className="grid gap-6 grid-cols-1 md:grid-cols-12">
                    <div className="card">
                        <header className="card-header">
                            <p className="card-header-title">
                                <span className="icon"><i className="mdi mdi-reorder-horizontal"></i></span>
                                Edit  {/* Add booking to {name} */}
                            </p>
                        </header>
                        <div className="card-content">
                            <form onSubmit={handleEdit}>
                                {alert.message && (
                                    <AlertMessage
                                        type={alert.type}
                                        message={alert.message}
                                        onClose={() => setAlert({ type: "", message: "" })}
                                    />
                                )}

                                <input className="input" name="coupons" id="coupons" type="hidden" readOnly value={formData.couponID} />
                                <div className="field">
                                    <label className="label">Select User <span style={{ color: "red" }}>*</span></label>
                                    <div className="control">
                                        <div className="select">
                                            <select id="users" value={formData.users} onChange={e => setFormData({ ...formData, users: e.target.value })}>
                                                <option value={''}>---Select---</option>
                                                {allUsers.map((user, index) => (
                                                    <option value={user.$id}>{user.email}</option>
                                                ))}
                                            </select>
                                            {errors.users && <p className="help" style={{ color: 'red' }}>{errors.users}</p>}
                                        </div>
                                    </div>
                                </div>

                                <div className="grid sm:gap-0 md:gap-6 md:grid-cols-2 sm:grid-cols-1 sm:mb-3">
                                    <div className="field">
                                        <label className="label" htmlFor="latitude">Latitude <span style={{ color: "red" }}>*</span></label>
                                        <div className="control">
                                            <input className="input" readOnly id="latitude" type="text" placeholder="Latitude" value={formData.latitude} onChange={e => setFormData({ ...formData, latitude: e.target.value })} />
                                        </div>
                                        {errors.latitude && <p className="help" style={{ color: 'red' }}>{errors.latitude}</p>}
                                    </div>
                                    <div className="field">
                                        <label className="label" htmlFor="longitude">Longitude <span style={{ color: "red" }}>*</span></label>
                                        <div className="control">
                                            <input className="input" readOnly id="longitude" type="text" placeholder="Longitude" value={formData.longitude} onChange={e => setFormData({ ...formData, longitude: e.target.value })} />
                                        </div>
                                        {errors.longitude && <p className="help" style={{ color: 'red' }}>{errors.longitude}</p>}
                                    </div>
                                </div>
                                <div className="field">
                                    <div className="control">
                                        {/* <GoogleMapComponent onLocationSelect={handleLocationSelect} /> */}

                                        <GoogleMapComponent
                                            onLocationSelect={handleLocationSelect}
                                            defaultPosition={{ lat: Number(formData.latitude), lng: Number(formData.longitude) }} // edit lat/lng
                                        />
                                    </div>
                                </div>
                                <div className="flex justify-center items-center">
                                    <div className="field grouped">
                                        <div className="control">
                                            <button type="submit" className="button green">
                                                Submit
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    )
}

export default EditCouponRedemtion;